"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var typescript_authentication_general_1 = require("@gaf/typescript-authentication-general");
var typescript_jwt_1 = require("@gaf/typescript-jwt");
var GafOktaSession_1 = require("../models/GafOktaSession");
var gaf_okta_setup_1 = require("../helpers/gaf-okta-setup");
var general_helpers_1 = require("../helpers/general-helpers");
var GafOkta = /** @class */ (function (_super) {
    __extends(GafOkta, _super);
    function GafOkta(config, callbacks, tokenManager, storage, windowLocation) {
        var _this = _super.call(this, storage) || this;
        _this.config = config;
        _this.callbacks = callbacks;
        _this.tokenManager = tokenManager;
        _this.storage = storage;
        _this.windowLocation = windowLocation;
        _this._jwtHelper = new typescript_jwt_1.GafJwtHelper();
        _this._setup = new gaf_okta_setup_1.GafOktaSetup(_this.windowLocation);
        return _this;
    }
    //#region protected functions to share
    GafOkta.prototype.areScopesProvided = function () {
        var scopes = this.config.scopes;
        return scopes !== undefined && scopes !== null && scopes.length >= 0;
    };
    GafOkta.prototype.isSingleAudience = function () {
        var scopes = this.config.scopes;
        return this.areScopesProvided() && typeof scopes[0] === 'string';
        // return this.areScopesProvided() && scopes instanceof Array;
    };
    GafOkta.prototype.isChildMode = function () {
        return this.config.mode === undefined || this.config.mode === typescript_authentication_general_1.GafAuthenticationMode.Child;
    };
    GafOkta.prototype.getChildRedirectUri = function () {
        if (this.config.issuer !== undefined && this.config.issuer !== null && this.config.issuer !== '') {
            return this.config.issuer + "?redirectURL=" + this.windowLocation.pathname;
        }
        return window.location.pathname;
    };
    /**
     * Load positive result into session
     * @param result result from Okta
     */
    GafOkta.prototype.setAuthSession = function (result) {
        if (result !== undefined &&
            result !== null
        // result.idTokenPayload !== undefined &&
        // result.idTokenPayload !== null
        ) {
            var _a = result.tokens || {}, accessToken = _a.accessToken, idToken = _a.idToken;
            var info = new GafOktaSession_1.GafOktaSession();
            if (accessToken !== undefined && accessToken !== null && idToken !== undefined && idToken !== null) {
                info.accessToken = accessToken.value;
                if (idToken) {
                    info.idToken = idToken.value;
                    info.profile = {
                        email: idToken.claims.email,
                        firstName: idToken.claims.firstname || idToken.claims.firstName,
                        lastName: idToken.claims.lastname || idToken.claims.lastName,
                    };
                }
                else {
                    info.idToken = this.storage.info.idToken;
                    info.profile = this.storage.info.profile;
                }
            }
            else {
                info.accessToken = result[0].accessToken;
                info.idToken = result[1] ? result[1].idToken : this.storage.info.idToken;
                if (result[1]) {
                    info.profile = {
                        email: result[1].claims.email,
                        firstName: result[1].claims.firstname,
                        lastName: result[1].claims.lastname,
                    };
                }
                else {
                    info.profile = this.storage.info.profile;
                }
            }
            // if (result && result.refreshToken) {
            //   info.refreshToken = result.refreshToken;
            // }
            this.storage.info = info;
        }
        // whenever we update this information, reschedule the ID token refresh based on the new token
        this.scheduleRenewal();
    };
    /**
     * Callback from Okta checkSession
     * @param err Err from Okta
     * @param result Result from Okta
     * @param promise Promise Resolve/Reject if needed
     */
    GafOkta.prototype.checkSessionCallback = function (err, result, promise) {
        if (err) {
            // if we have an error, call login
            // Below if condition is to availd infite login call on sdk error
            if (err.errorCode === 'login_required' || err.errorCode === 'INTERNAL') {
                this.login();
            }
            else if (promise && promise.reject) {
                promise.reject(err);
            }
        }
        else {
            // save this information in session
            if (result !== undefined && result !== null) {
                this.setAuthSession(result);
                var accessToken = (result.tokens || {}).accessToken;
                // if this is a single audience, save the access token in the cache as well
                if (!this.areScopesProvided() || this.isSingleAudience()) {
                    if (accessToken !== undefined && accessToken !== null) {
                        this.tokenManager.set(this.config.issuer, accessToken.value);
                    }
                    else {
                        this.tokenManager.set(this.config.issuer, result[0].accessToken);
                    }
                }
            }
            // call the resolve state
            if (promise && promise.resolve) {
                promise.resolve(true);
            }
        }
    };
    GafOkta.prototype.getStandardPromiseFunction = function (promise) {
        var _this = this;
        // create an empty promise object if one does not exist
        if (promise === undefined || promise === null) {
            promise = {};
        }
        // see if we are logged in at this moment.  If not, when we do log in we can emit event.
        var loggedIn = this.isAuthenticated;
        // call the resolve configured outside of this method but also
        // emit the successful login event.
        var oldResolve = promise.resolve;
        promise.resolve = function (value) {
            if (typeof oldResolve === 'function') {
                oldResolve(value);
            }
            // if not logged in, then we will emit message if in child mode
            if (!loggedIn && typeof _this.callbacks.onAuthenticationChanged === 'function') {
                _this.callbacks.onAuthenticationChanged(true);
            }
        };
        return promise;
    };
    /**
     * Clear session information from storage for okta settings
     */
    GafOkta.prototype.clearSessionInfo = function () {
        this.storage.clear();
        if (this._timeoutPointer !== undefined) {
            clearTimeout(this._timeoutPointer);
        }
        if (this._timeoutPointerAccessToken) {
            clearTimeout(this._timeoutPointerAccessToken);
        }
    };
    /**
     * Schedule renewals of the id token
     */
    GafOkta.prototype.scheduleRenewal = function () {
        var _this = this;
        if (this.config.setupRefreshTimers === undefined || this.config.setupRefreshTimers === true) {
            // determine length of time that can be used for renewal scheduling.
            // use the token and the threshold
            var sessionInfo = this.storage.info;
            if (sessionInfo !== undefined && sessionInfo !== null && !general_helpers_1.GeneralHelpers.isNullOrEmpty(sessionInfo.accessToken)) {
                var threshold = this.config.idTokenThreshold || 30 * 1000; // 30 seconds by default
                var expirationTime = this._jwtHelper.getTokenExpirationDate(sessionInfo.idToken).getTime();
                var nowTime = new Date().getTime();
                var timerLength = expirationTime - nowTime - threshold;
                // const expirationTime: Date | null = this._jwtHelper
                //   .getTokenExpirationDate(sessionInfo.idToken);
                // const nowTime: number | null = expirationTime? expirationTime.getTime(): null;
                // const timerLength = 12345;
                if (timerLength <= 0) {
                    this.renewIdToken();
                }
                else {
                    if (this._timeoutPointer) {
                        clearTimeout(this._timeoutPointer);
                    }
                    this._timeoutPointer = window.setTimeout(function () {
                        _this.renewIdToken();
                    }, timerLength);
                }
                var expirationAccessTokenTime = this._jwtHelper.getTokenExpirationDate(sessionInfo.accessToken).getTime();
                var accessTokenTimerLength = expirationAccessTokenTime - nowTime - threshold;
                if (accessTokenTimerLength <= 0) {
                    this.renewAccessToken();
                }
                else {
                    if (this._timeoutPointerAccessToken) {
                        clearTimeout(this._timeoutPointerAccessToken);
                    }
                    this._timeoutPointerAccessToken = window.setTimeout(function () {
                        _this.renewAccessToken();
                    }, accessTokenTimerLength);
                }
            }
        }
    };
    //#region Public interfaces
    /**
     * Login to Okta
     */
    GafOkta.prototype.start = function () {
        var _this = this;
        // if we are authenticated already, set tokens correctly
        if (this.isAuthenticated) {
            // if we are single audience, we could use the access token.  Next time we try
            // to actually use the token in a request, we will check if expired.
            if (this.isSingleAudience()) {
                this.tokenManager.set(this.config.issuer, this.storage.info.accessToken);
            }
            // mark our initial refresh state as resolved
            this._initialRenewIdTokenPromise = Promise.resolve(true);
            this.scheduleRenewal();
            if (typeof this.callbacks.onAuthenticationChanged === 'function') {
                this.callbacks.onAuthenticationChanged(true);
            }
        }
        else {
            // set a promise that will be driven by the refresh of the id token.
            // this allows us to WAIT on all requests until the ID token is done.
            this._initialRenewIdTokenPromise = new Promise(function (resolve, reject) {
                _this.renewIdToken({
                    resolve: function () { return resolve(true); },
                    reject: function () { return reject(false); },
                });
            });
        }
    };
    Object.defineProperty(GafOkta.prototype, "isAuthenticated", {
        /**
         * Is the user authenticated?
         */
        get: function () {
            // check to see if we are still authenticated
            var sessionInfo = this.storage.info;
            if (sessionInfo === undefined || sessionInfo === null || general_helpers_1.GeneralHelpers.isNullOrEmpty(sessionInfo.idToken)) {
                return false;
            }
            // check if the token has expired.
            return !this._jwtHelper.isTokenExpired(sessionInfo.idToken);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Get the email address from the session storage for other usages
     */
    GafOkta.prototype.getEmail = function () {
        if (this.isAuthenticated) {
            return this.storage.info.profile === undefined ? '' : this.storage.info.profile.email;
        }
        return '';
    };
    GafOkta.prototype.getAccessTokenfromOkta = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._initialRenewIdTokenPromise.then(function () {
                // determine if this is as single audience scope definition
                _this.getRenewToken({
                    resolve: function () { return resolve(_this.storage.info.accessToken); },
                    reject: function () { return resolve(); },
                });
            });
        });
    };
    /**
     * Get Access Token for a given url
     * @param url The url we are attempting to get the access token for
     */
    GafOkta.prototype.getAccessToken = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._initialRenewIdTokenPromise.then(function () {
                // determine if this is as single audience scope definition
                var key = _this.config.issuer;
                // if we do not get a key, we have an error state.
                if (key === undefined || key === null || key === '') {
                    if (typeof _this.callbacks.onRenewError === 'function') {
                        _this.callbacks.onRenewError('Audience String Is Missing');
                    }
                    resolve();
                }
                else {
                    // let's attempt to get the token from cache... if we can, and it's not expired, just use it
                    var item = _this.tokenManager.get(key, _this.config.accessTokenThreshold);
                    // if we have a token, use it
                    if (item !== undefined) {
                        resolve(item.value);
                        // if this is single audience, we can just call renewIdToken again with a callback
                    }
                    else {
                        // get the access token here.
                        // renew the id and access tokens here
                        _this.renewIdToken({
                            resolve: function () { return resolve(_this.storage.info.accessToken); },
                            reject: function () { return resolve(); },
                        });
                    }
                }
            });
        });
    };
    return GafOkta;
}(typescript_authentication_general_1.GafAuthentication));
exports.GafOkta = GafOkta;
